import React from "react";

function SvgIcMapPoi096(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M26 24v2H6v-2h20zm1.035-17l-2.352 9.055-1.447-3.877-5.529 5.529a.999.999 0 01-1.413 0L15 16.414l-4.293 4.293A1 1 0 0110 21H7a1 1 0 110-2h2.585l4.707-4.707a.999.999 0 011.415 0L17 15.586l4.86-4.861L18 9.166 27.035 7z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgIcMapPoi096;
